import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaSearch, FaChevronDown, FaChevronUp } from "react-icons/fa";
import AlertModal from "../../Components/AlertModal";
import { Link } from "react-router-dom";
import ProductModal from "./productModal";
import { BASE_URL } from "../../constants/Constants";
import apiClient from "../../AppClient";

const ProductsListScreen = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [groupedProducts, setGroupedProducts] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [hideZeroInventory, setHideZeroInventory] = useState(false);
  const [showOnlyActive, setShowOnlyActive] = useState(true);

  const rowsPerPage = 4;

  const fetchProducts = () => {
    setLoading(true);
    apiClient
      .get(`/products/`)
      .then((response) => {
        console.log("response:", response.data);
        setProducts(response.data);
        setFilteredProducts(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    let filtered = products.filter(product =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.id.toString().includes(searchTerm) ||
      product.category?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.sale_price.toString().includes(searchTerm)
    );
    
    // Apply hide zero inventory filter if checked
    if (hideZeroInventory) {
      filtered = filtered.filter(product => product.quantity_available > 0);
    }
    
    // Apply active status filter if checked
    if (showOnlyActive) {
      filtered = filtered.filter(product => product.is_active);
    }
    
    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  }, [searchTerm, products, hideZeroInventory, showOnlyActive]);

  // Group products by name
  useEffect(() => {
    const grouped = {};
    filteredProducts.forEach(product => {
      if (!grouped[product.name]) {
        grouped[product.name] = [];
      }
      grouped[product.name].push(product);
    });
    setGroupedProducts(grouped);
  }, [filteredProducts]);

  // Get unique product names for pagination
  const uniqueProductNames = Object.keys(groupedProducts);
  const totalPages = Math.ceil(uniqueProductNames.length / rowsPerPage);
  const paginatedProductNames = uniqueProductNames.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const toggleGroup = (productName) => {
    setExpandedGroups(prev => ({
      ...prev,
      [productName]: !prev[productName]
    }));
  };

  const handleAdd = () => {
    setModalMode("add");
    setSelectedProduct(null);
    setShowModal(true);
  };

  const handleEdit = (product) => {
    setModalMode("edit");
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    apiClient
      .delete(`/products/${id}/delete/`)
      .then((response) => {
        fetchProducts();
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container-fluid mt-4 p-4 bg-light rounded shadow-sm">
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4 border-bottom pb-3">
        {error && <div className="alert alert-danger w-100 mb-3">{error}</div>}
        <h2 className="mb-0" style={{ color: "darkgreen" }}>قائمة المنتجات</h2>
        <button 
          className="btn btn-success" 
          onClick={handleAdd}
          style={{ backgroundColor: "darkgreen", color: "white", borderColor: "darkgreen" }}
        >
          <i className="fas fa-plus me-2"></i> إضافة منتج جديد
        </button>
      </div>
      
      {/* Search and Filters Row */}
      <div className="mb-4 row align-items-center">
        {/* Search Bar */}
        <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
          <div className="input-group shadow-sm">
            <input
              type="text"
              className="form-control"
              placeholder="ابحث بالاسم, ID, التصنيف, السعر..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ borderColor: "darkgreen" }}
            />
            <span 
              className="input-group-text" 
              style={{ backgroundColor: "darkgreen", color: "white", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            >
              <FaSearch />
            </span>
          </div>
        </div>
        
        {/* Filter Controls */}
<div className="col-md-6 col-lg-8">
        <div className="d-flex flex-wrap gap-4 align-items-center">
          {/* Hide Zero Inventory Checkbox - Enhanced */}
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="hideZeroInventory"
              checked={hideZeroInventory}
              onChange={(e) => setHideZeroInventory(e.target.checked)}
              style={{
                width: "2.5em",
                height: "1.3em",
                backgroundColor: hideZeroInventory ? "darkgreen" : "#ccc",
                borderColor: "darkgreen",
                cursor: "pointer",
                boxShadow: "none"
              }}
            />
            <label 
              className="form-check-label fw-bold ms-2" 
              htmlFor="hideZeroInventory"
              style={{ cursor: "pointer" }}
            >
              إخفاء المنتجات بدون مخزون
            </label>
          </div>
          
          {/* Show Only Active Checkbox - Enhanced */}
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="showOnlyActive"
              checked={showOnlyActive}
              onChange={(e) => setShowOnlyActive(e.target.checked)}
              style={{
                width: "2.5em",
                height: "1.3em",
                backgroundColor: showOnlyActive ? "darkgreen" : "#ccc",
                borderColor: "darkgreen",
                cursor: "pointer",
                boxShadow: "none"
              }}
            />
            <label 
              className="form-check-label fw-bold ms-2" 
              htmlFor="showOnlyActive"
              style={{ cursor: "pointer" }}
            >
              إظهار المنتجات النشطة فقط
            </label>
          </div>
        </div>
      </div>

      </div>
      
      <div className="table-responsive shadow-sm rounded">
        <table className="table table-bordered table-hover text-center align-middle mb-0">
          <thead className="table-dark" style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">اسم المنتج</th>
              <th scope="col" className="d-none d-md-table-cell"> نوع الصنف</th>
              <th scope="col"> التصنيف </th>
              <th scope="col" className="d-none d-md-table-cell"> سعر البيع</th>
              <th scope="col" className="d-none d-md-table-cell"> المخزون </th>
              <th scope="col">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {paginatedProductNames.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-muted p-4">لا يوجد منتجات تطابق البحث أو لم يتم إضافة منتجات بعد.</td>
              </tr>
            ) : (
              paginatedProductNames.map((productName) => (
                <React.Fragment key={productName}>
                  {/* Group header row */}
                  <tr className="table-light" style={{ cursor: "pointer" }} onClick={() => toggleGroup(productName)}>
                    <td colSpan={7} className="border border-5 fw-bold text-start px-3 py-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <span>{productName}</span>
                        {expandedGroups[productName] ? <FaChevronUp className="text-secondary"/> : <FaChevronDown className="text-secondary"/>}
                      </div>
                    </td>
                  </tr>
                  
                  {/* Expanded rows for products in this group */}
                  {expandedGroups[productName] && groupedProducts[productName].map((product, index) => (
                    <tr key={`${productName}-${index}`}>
                      <td>{product.id}</td>
                      <td className="text-wrap">{product.name}</td>
                      <td className="text-wrap d-none d-md-table-cell">
                        {product.category?.name}{product.category?.subCategory ? `-${product.category.subCategory.name}` : ''}{product.category?.subCategory?.nodeCategory ? `-${product.category.subCategory.nodeCategory.name}` : ''}
                      </td>
                      <td>{product.classification}</td>
                      <td className="text-wrap d-none d-md-table-cell">
                        {product.sale_price}
                      </td>
                      <td className="text-wrap d-none d-md-table-cell" style={{
                        color: product.quantity_available <= 0 ? 'red' : 'green',
                        fontWeight: 'bold'
                      }}>
                        {product.quantity_available}
                        {!product.is_active && <span className="ms-2 badge bg-secondary">غير نشط</span>}
                      </td>
                      <td className="text-nowrap">
                        <Link
                          to={`/products/${product.id}`}
                          className="btn btn-sm btn-info text-white mx-1"
                          title="عرض التفاصيل"
                        >
                          <i className="far fa-eye"></i>
                        </Link>

                        <button
                          className="btn btn-sm btn-success text-white mx-1"
                          onClick={() => handleEdit(product)}
                          title="تعديل"
                        >
                          <FaEdit />
                        </button>
                        <AlertModal
                          customebutton={
                            <button 
                              className="btn btn-sm btn-danger text-white mx-1"
                              title="حذف"
                            >
                              <FaTrash />
                            </button>
                          }
                          title="حذف المنتج"
                          message={`هل أنت متأكد من حذف المنتج "${product.name}" (ID: ${product.id})؟`}
                          myaction={() => handleDelete(product.id)}
                          savetitle="تأكيد الحذف"
                        />
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <nav aria-label="Page navigation" className="mt-4 d-flex justify-content-center">
          <ul className="pagination shadow-sm">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                style={{ 
                  color: currentPage !== 1 ? "darkgreen" : ""
                }}
              >
                السابق
              </button>
            </li>
            <li className="page-item disabled">
              <span className="page-link" style={{ color: "darkgreen" }}>
                صفحة {currentPage} من {totalPages}
              </span>
            </li>
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                 style={{ 
                  color: currentPage !== totalPages ? "darkgreen" : ""
                }}
              >
                التالي
              </button>
            </li>
          </ul>
        </nav>
      )}

      <ProductModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        productData={selectedProduct}
        refreshData={fetchProducts}
      />
    </div>
  );
};

export default ProductsListScreen;